// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "content-iQ-qj";
var _4 = "title-3QXgQ";
var _5 = "text-3EKAz";
var _6 = "linked-e0u5q";
export { _1 as "__esModule", _2 as "mobile", _3 as "content", _4 as "title", _5 as "text", _6 as "linked" }
export default { "__esModule": _1, "mobile": _2, "content": _3, "title": _4, "text": _5, "linked": _6 }
